module.exports = __webpack_public_path__ + "static/media/logo.d0534fd7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.svg
// module id = 679
// module chunks = 9